export const MODULE_NAMES = {
  BM: 'bm',
  PM: 'pm',
  Gateway: 'gateway',
} as const

export type Modules = (typeof MODULE_NAMES)[keyof typeof MODULE_NAMES]

export type ModuleViewedResponse = {
  [MODULE_NAMES.BM]?: boolean
  [MODULE_NAMES.PM]?: boolean
  [MODULE_NAMES.Gateway]?: boolean
}
